
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import supabase from './supabaseClient';

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [rfqs, setRfqs] = useState([]);
  const [deals, setDeals] = useState([]);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    loadUserAndData();
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const loadUserAndData = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    setUser(user);
    if (!user) return;

    const { data: rfqData } = await supabase
      .from('rfq_requests')
      .select('id, side, status, expires_at, rfq_request_items(amount, securities(name, isin))')
      .eq('user_id', user.id)
      .order('created_at', { ascending: true });

    setRfqs(rfqData || []);
    scheduleRfqs(rfqData || []);

    const { data: dealsData } = await supabase
      .from('deals')
      .select('*')
      .or(`buyer_id.eq.${user.id},seller_id.eq.${user.id}`);
    setDeals(dealsData || []);
  };

  const scheduleRfqs = (list) => {
    list.forEach(rfq => {
      if (rfq.status !== 'open') return;
      const timeoutMs = new Date(rfq.expires_at + 'Z').getTime() - Date.now();
      if (timeoutMs > 0) {
        setTimeout(async () => {
          console.log("⏳ RFQ истёк:", rfq.id);
          await supabase.from('rfq_requests').update({ status: 'timed out' }).eq('id', rfq.id);
          await loadUserAndData();
        }, timeoutMs);
      }
    });
  };

  const cancelRfq = async (id) => {
    await supabase.from('rfq_requests').update({ status: 'cancelled' }).eq('id', id);
    await loadUserAndData();
  };

  const clearCompletedRfqs = async () => {
    const done = rfqs.filter(r => r.status !== 'open');
    for (const r of done) {
      await supabase.from('rfq_requests').delete().eq('id', r.id);
    }
    await loadUserAndData();
  };

  const getTimerStyle = (seconds) => {
    if (seconds <= 30) return { color: 'red' };
    if (seconds <= 60) return { color: 'orange' };
    return { color: 'green' };
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Личный кабинет</h2>
      {user ? (
        <>
          <p>Вы вошли как: {user.email}</p>

          <hr />
          <h3>Мои RFQ</h3>
          <button onClick={clearCompletedRfqs} style={{ marginBottom: '1rem' }}>Очистить завершённые</button>
          {rfqs.length === 0 ? (
            <p>Нет заявок.</p>
          ) : (
            <ol>
              {rfqs.map((rfq, index) => {
                const exp = new Date(rfq.expires_at + 'Z').getTime();
                const rem = Math.floor((exp - now) / 1000);

                return (
                  <li key={rfq.id} style={{ marginBottom: '1rem' }}>
                    <strong>{rfq.side.toUpperCase()}</strong> — Срок: {rfq.expires_at?.split('T')[0]}
                    {rfq.status === 'open' && (
                      <div style={{ marginTop: '0.3rem', ...getTimerStyle(rem) }}>
                        ⏳ {Math.floor(rem / 60)}:{(rem % 60).toString().padStart(2, '0')}
                      </div>
                    )}
                    <br />
                    <b>Бумаги:</b>
                    <ul>
                      {rfq.rfq_request_items?.map((item, idx) => (
                        <li key={idx}>
                          {item.securities?.name} ({item.securities?.isin}) — {Number(item.amount).toLocaleString('ru-RU')}
                        </li>
                      ))}
                    </ul>
                    <div>Статус: <b>{rfq.status}</b></div>
                    {rfq.status === 'open' && (
                      <>
                        <button onClick={() => alert('Редактирование пока не реализовано')} style={{ marginRight: 5 }}>Редактировать</button>
                        <button onClick={() => cancelRfq(rfq.id)}>Отменить</button>
                      </>
                    )}
                  </li>
                );
              })}
            </ol>
          )}

          <hr />
          <h3>Мои сделки</h3>
          {deals.length === 0 ? (
            <p>Сделок пока нет.</p>
          ) : (
            <ul>
              {deals.map((deal) => (
                <li key={deal.id}>
                  <Link to={`/deal/${deal.id}`}>
                    Сделка #{deal.id} — Цена: {deal.price}, Объём: {Number(deal.amount).toLocaleString('ru-RU')}, Дата: {deal.trade_date?.split('T')[0]}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </>
      ) : (
        <p>Загрузка...</p>
      )}
    </div>
  );
}
